export function getCellValueFromGroup(group, idx) {
  for (const r of group) {
    const v = r.relations?.TableCellsList?.[idx]?.fields?.title;
    if (v !== undefined && v !== null && String(v).trim() !== '') {
      return v;
    }
  }
  return '';
}
